import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'utils/Formatters';

const ActionsTable = ({ actions }) => {
  const { t } = useTranslation();
  return (
  <div className='o-card__wrap'>
    <section className='column o-card cs-bg--light'>
      <h4><b>{t('administration.staff.actions.title')}</b></h4>
      {actions.length === 0 ? (
        <p>{t('administration.staff.actions.noActions')}</p>
      ) : (
        <table className='o-table o-table--bordered'>
          <thead>
            <tr>
              <th>{t('administration.staff.actions.columns.id')}</th>
              <th>{t('administration.staff.actions.columns.type')}</th>
              <th>{t('administration.staff.actions.columns.createdAt')}</th>
            </tr>
          </thead>
          <tbody>
            {actions.map((action) => (
              <tr key={action.id}>
                <td>{action.id}</td>
                <td>{action.action_type}</td>
                <td>{formatDate(action.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  </div>
  );
}

ActionsTable.propTypes = {
  actions: PropTypes.array.isRequired,
}

export default ActionsTable;
